"use strict";

define('libs/loader.helper',['backbone', 'underscore', 'uikit/uikit', 'uikit/views/error', 'datakit/ajax'], function (Backbone, _, UIKit, ErrorView, ajax) {
  var ComponentCollectionView = UIKit.Container;
  var Loader = UIKit.Loader;
  var ButtonView = UIKit.Button;
  var LoaderHelper = Backbone.Model.extend({
    constructor: function constructor(models, options) {
      this.requesting = 0;
      options = _.extend({
        delay: 1000
      }, options);
      this.options = options;
      this.attributes = {};
      this.set({
        loading: false
      });
      this.changed = {};
      _.each(_.isArray(models) ? models : models ? [models] : null, function (model) {
        this.add(model);
      }, this);
      if (options.dimmer) {
        this.bindDimmer(options.dimmer);
      }
    },
    bindDimmer: function bindDimmer(dimmer) {
      var content = new ComponentCollectionView(),
        loader = new Loader({
          active: false
        }),
        button = new ButtonView({
          text: 'Retry',
          visible: false,
          color: 'red',
          inverted: true,
          icon: 'refresh'
        }),
        error = new ErrorView();
      button.on('press', function () {
        this.trigger('retry');
      }, this);
      content.add(error).add(loader);
      error.model = this;
      error.bindings.text = 'error';
      this.on('change:loading', function () {
        var hasError = !!this.get('error');
        if (this.get('loading')) {
          this.set('error', false);
          dimmer.active = true;
          loader.active = true;
        } else if (!hasError) {
          dimmer.active = false;
          loader.active = false;
        } else {
          loader.active = false;
        }
      });
      this.on('change:error', function () {
        if (!!this.get('error')) {
          dimmer.active = true;
          button.visible = true;
          error.visible = true;
        } else {
          error.visible = false;
          button.visible = false;
        }
      });
      dimmer.content = content;
      return this;
    },
    add: function add(model) {
      this.listenTo(this, 'retry', function () {
        model.fetch();
      });
      this.listenTo(model, 'request', function () {
        var self = this;
        this.requesting++;
        if (this.requesting == 1) {
          if (this._alreadyRun && !this.get('error')) {
            setTimeout(function () {
              if (self.requesting > 0) {
                self.set('loading', true);
              }
            }, this.options.delay);
          } else {
            this._alreadyRun = true;
            this.set('loading', true);
          }
        }
      });
      this.listenTo(model, 'sync error destroy', function () {
        this.requesting--;
        if (this.requesting <= 0) {
          this.requesting = 0;
          this.set('loading', false);
        }
      });
      this.listenTo(model, 'error', function (model, err, options) {
        if (err instanceof ajax.AbortError) {
          return;
        }
        this.set('error', err.message);
      });
      return model;
    }
  });
  return LoaderHelper;
});

